import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { message } from '@utils/index';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { useConstructor } from './use-constructor';

export function useGenerateConstructor() {
  const {
    i18n: { language }
  } = useTranslation();
  const {
    upload: { id, count = 0 },
    methods: { setUpload }
  } = useConstructor();

  return useMutation(
    async (payload: any) => {
      const { data } = await $api.post(`/v1/excel-constructor/generate?lang=${language?.toUpperCase()}`, {
        ...payload,
        templateId: id
      });

      return { data };
    },
    {
      onError: baseErrorHandler,
      onSuccess: async data => {
        message.success(data?.data?.message?.[language]);

        if (count < 1000) {
          setUpload({
            visible: false
          });
        }
      }
    }
  );
}
